'use client'

import Image from 'next/image'

import { Card, CardContent } from '@/components/ui/card'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import { useTranslations } from 'next-intl'

export const AmazonCarouselSection = () => {
  const t = useTranslations('ldp_amazon_hardcode.carousel')

  const carouselItems = [
    {
      title: t('item1.title'),
      subtitle: t('item1.subtitle'),
      description: t.rich('item1.description', {
        bold: (chunks) => <span className='font-semibold'>{chunks}</span>,
      }),
      hashtags: t('hashtags'),
      image: '/image/September2025/mceclip11_72.jpg',
    },
    {
      title: t('item2.title'),
      subtitle: t('item2.subtitle'),
      description: t.rich('item2.description', {
        bold: (chunks) => <span className='font-semibold'>{chunks}</span>,
      }),
      hashtags: t('hashtags'),
      image: '/image/September2025/mceclip12.jpg',
    },
  ]
  return (
    <div
      className='relative overflow-hidden py-12 md:py-16'
      style={{
        background: 'linear-gradient(90.94deg, #1A1A1A 0%, #333333 100%)',
      }}
    >
      <Image
        src={ImageHelper.getImageUrl('/image/September2025/mceclip9_54.png')}
        alt='Background'
        fill
        className='absolute inset-0 left-0 !w-auto object-contain'
      />
      <Carousel
        opts={{
          align: 'start',
          loop: true,
        }}
        plugins={[
          Autoplay({
            delay: 5000,
            stopOnInteraction: false,
          }),
        ]}
        className='relative w-full'
      >
        <CarouselContent>
          {carouselItems.map((item, index) => (
            <CarouselItem key={index}>
              <div className='p-1'>
                <Card className='border-none bg-transparent text-white shadow-none'>
                  <CardContent className='grid grid-cols-1 items-center gap-4 px-5 md:grid-cols-2 md:gap-12 md:px-15'>
                    {/* Text Column */}
                    <div className='grid h-full grid-rows-[1fr_auto] gap-2 text-center md:gap-6 md:text-left'>
                      {/* Main Content */}
                      <div>
                        <Image
                          src={ImageHelper.getImageUrl(
                            '/image/September2025/mceclip8_7.png'
                          )}
                          alt='Icon'
                          width={80}
                          height={80}
                          className='mx-auto h-10 w-10 object-contain md:mx-0 md:h-20 md:w-20'
                        />
                        <h3 className='mt-4 font-criteria text-2xl font-semibold md:text-4xl 2xl:text-6xl'>
                          {item.title}
                        </h3>
                        <p className='mt-2 font-criteria text-base font-light text-secondary-500 md:mt-4 md:text-[28px]'>
                          {item.subtitle}
                        </p>
                        <p className='mt-2 text-base md:mt-10 md:text-2xl'>
                          {item.description}
                        </p>
                      </div>
                      {/* Hashtags at the bottom */}
                      <p className='text-sm italic text-secondary-500 md:text-lg'>
                        {item.hashtags}
                      </p>
                    </div>
                    {/* Image Column */}
                    <div className='w-full'>
                      <Image
                        src={ImageHelper.getImageUrl(item.image)}
                        alt={item.title}
                        width={600}
                        height={400}
                        className='h-auto w-full rounded-lg object-cover'
                      />
                    </div>
                  </CardContent>
                </Card>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
    </div>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute left-2 top-1/2 h-10 w-10 -translate-y-1/2'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute right-2 top-1/2 h-10 w-10 -translate-y-1/2'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
